import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

const useGetInvestmentReport = (policyNumber, enabled) => {
  return useQuery({
    queryKey: ['investmentReport', policyNumber],
    queryFn: async () => {
      const response = await apiClient.get('/life/investment-report', {
        params: { policy_number: policyNumber },
      });
      return response.data;
    },
    enabled: enabled && !!policyNumber,
  });
};

export { useGetInvestmentReport };